import { LS_TOKEN, PAGE_LOGIN } from "@/shared/constants";
import { useRoleManager } from "@/shared/services/useRoleManager";
// import { EmptySection } from "@/widgets/empty-section/EmptySection";
import { AuthUser, Layout, SuspenseSite } from "@/widgets/layout";
import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAppSelector } from "../../store/storeHooks";
import { privateRoutes, teacherRoutes } from "./private-routes";
import { EmptySection } from "@/widgets/empty-section/EmptySection";
import Login from "@/pages/login";

/**
 * The main application router.
 * This component is responsible for defining the application's routing structure.
 * @returns The rendered routes.
 */

export const AppRouter = () => {
  const { type } = useAppSelector((state) => state?.LoginState?.loginData);
  const hasAccess = useRoleManager();
  const { t } = useTranslation();

  const isAuthenticated = !!localStorage.getItem(LS_TOKEN);

  return (
    <Routes>
      <Route path={PAGE_LOGIN} element={<Login />} />
      <Route
        path="/"
        element={
          isAuthenticated ? <AuthUser /> : <Navigate to={PAGE_LOGIN} replace />
        }
      >
        <Route element={<SuspenseSite />}>
          <Route element={<Layout />}>
            {type === "admin" ? (
              <Route element={<SuspenseSite />}>
                {privateRoutes.map((route, i) => {
                  if (route.role && hasAccess(route.role))
                    return (
                      <Route
                        element={route.element}
                        path={route.path}
                        index={route.index}
                        key={route.path ?? i}
                      />
                    );
                  else return null;
                })}
              </Route>
            ) : (
              <Route element={<SuspenseSite />}>
                {teacherRoutes.map((route, i) => {
                  if (route.role && hasAccess(route.role))
                    return (
                      <Route
                        element={route.element}
                        path={route.path}
                        index={route.index}
                        key={route.path ?? i}
                      />
                    );
                  else return null;
                })}
              </Route>
            )}
          </Route>
        </Route>
      </Route>
      <Route
        path="*"
        element={<EmptySection title={t("PAGES_TITLE.PAGES_NOT_FOUND")} />}
      />
    </Routes>
  );
};
